import { ProtobufClient } from 'api/protobuf/protobuf-client';
import { goBackendApi } from 'hooks/api/httpApi';
import { AggregatorsResponse, AggregatorsResponseSchema } from '../../../pb/responses/v1/aggregators_response_pb';

export const fetchAggregators = async (): Promise<AggregatorsResponse> => {
    const pbClient = new ProtobufClient(goBackendApi());
    return pbClient.getRequest(AggregatorsResponseSchema, '/api/v1/aggregators/').then((res) => res);
};
